
import "./CustomPopup.css"

const CustomPopup = ({ isOpen, onClose }) => {
  if (!isOpen) return null

  return (
    <div className="save-reminder-overlay">
      <div className="save-reminder-popup">
        <div className="save-reminder-content">
          <h3>Reminder</h3>
          <p>Kindly remember to save your changes.</p>
          <button onClick={onClose} className="save-reminder-button">
            Got it
          </button>
        </div>
      </div>
    </div>
  )
}

export default CustomPopup

